import * as React from "react"
import DetailGroupModalComponent, { Names } from "./detail-group-modal-component"
import { LocalAuthority, ServiceGroup } from "../../../model"
import { createServiceGroup, findOneServiceGroup, updateServiceGroup } from "../../../service/sfp/service-group-service"
import { deleteServiceGroup } from "../../../service/sfp/service-group-service"

export default class DetailGroupModal
extends React.Component<DetailGroupModalProps, State> {
	constructor(props: DetailGroupModalProps) {
		super(props)
		this.state = {
			loadingGroup: false,
			group: props.group,
			groupLoaded: false,
			submitting: false
		}
	}

	componentDidMount() {
		this.initData(this.props)
	}

	componentWillReceiveProps(props) {
		this.initData(props)
	}

	render() {
		return <DetailGroupModalComponent
		loadingGroup={this.state.loadingGroup}
		localAuthority={this.props.localAuthority}
		group={this.state.group}
		submitting={this.state.submitting}
		onClickCloseButton={this.props.onClose}
		onClickDeleteButton={(b, e) => this.props.onGroupDeleted(this.state.group)}
		onClickFooterButton={(b, e) => this.props.onClose(e)}
		onSubmit={e => this.handleSubmit(e)} />
	}

	private createServiceGroup(values: FormValues): void {
		createServiceGroup(this.props.localAuthority, values.label)
		.then(serviceGroup => {
			this.setState({ submitting: false })
			this.props.onGroupCreated(serviceGroup)
		})
		.catch(reason => {
			this.setState({ submitting: false })
			this.props.onError(reason)
		})
	}

	private getFormValues(form: HTMLFormElement): FormValues {
		const formData = new FormData(form)
		return {
			label: this.getLabelValue(formData),
			localAuthority: this.props.localAuthority.id
		}
	}

	private getLabelValue(formData: FormData): string {
		return formData.get(Names.Label).toString()
	}

	private handleSubmit(e: React.SyntheticEvent<Element>): void {
		e.preventDefault()
		this.setState({ submitting: true })

		const form = e.target as HTMLFormElement
		const values = this.getFormValues(form)
		const group = this.state.group

		if (this.state.group) this.updateGroup(group, values)
		else this.createServiceGroup(values)
	}

	private initData(props: DetailGroupModalProps): void {
		if (!props.group) return
		if (this.state.groupLoaded) return

		this.setState({ loadingGroup: true })

		findOneServiceGroup(props.localAuthority, props.group.id)
		.then(group => this.setState({
			loadingGroup: false,
			group,
			groupLoaded: true
		}))
		.catch(reason => {
			this.setState({ loadingGroup: false, groupLoaded: false })
			this.props.onError(reason)
		})
	}

	private updateGroup(group: ServiceGroup, values: FormValues): void {
		group.label = values.label !== group.label ? values.label : undefined
		group.localAuthority = this.props.localAuthority.id

		updateServiceGroup(this.props.localAuthority, group)
		.then(group => {
			this.setState({ submitting: false })
			this.props.onGroupUpdated(group)
		})
		.catch(reason => {
			this.setState({ submitting: false })
			this.props.onError(reason)
		})
	}
}

export { Names }

export interface DetailGroupModalProps {
	group?: ServiceGroup
	Politique?:any
	localAuthority: LocalAuthority
	onClose(e: React.SyntheticEvent<Element>): void
	onError(reason: any): void
	onGroupCreated?(serviceGroup: ServiceGroup): void
	onGroupUpdated?(serviceGroup: ServiceGroup): void
	onGroupDeleted?(serviceGroup: ServiceGroup): void
}

interface FormValues {
	label: string
	localAuthority: number
}

interface State {
	loadingGroup: boolean
	group: ServiceGroup
	groupLoaded: boolean
	submitting: boolean
}


// WEBPACK FOOTER //
// ./src/component/services/detail-group-modal/index.tsx